import { AutogenLayoutFederalTaxTable } from "./autogen/AutogenLayoutFederalTaxTable";
import { ClickEvent, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, Layout, SlideoutDecorator, ValidationResult } from "@mcleod/components";
import { FieldUpdateEvent } from "@mcleod/core";

export class FederalTaxTable extends AutogenLayoutFederalTaxTable {

    onLoad() {
        this.sourceFedtaxtable.addAfterExecutionListener(this.sourceFedtaxtableAfterExecution.bind(this));
        this.addLayoutDataLoadListener(() => {
            this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
                if (event.fieldName === "enable_catchup" || event.fieldName === "enable_roth") {
                    this.setAccounts();
                }
                if (event.fieldName === "use_auto_tax_table") {
                    this.setWithholdingInfo();
                }
            });
        })
        this.buttonVersion.addClickListener((event: ClickEvent) => {
            const layout = Layout.getLayout("lme/settlement/TaxControlVersion");
            SlideoutDecorator.decorateAndSlideIn(layout, {
                title: "Tax Control Version",
                fillVerticalSpace: true,
                width: "40%"
            });
        });
        this.textboxHigherCatchupBegAge.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult =>{
            if (mode === DataSourceMode.SEARCH) {
                return null;
            }

            if(!this.textboxHigherCatchupEndAge.isEmpty()){
                if (this.textboxHigherCatchupBegAge.getDataValue()> this.textboxHigherCatchupEndAge.getDataValue()) {
                    return {
                        isValid: false,
                        validationMessage: "Beginning age must be before or equal to ending age.",
                        component: this.textboxHigherCatchupBegAge
                    };
                }
            }
            return null;
        };

        this.textboxHigherCatchupEndAge.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult =>{
            if (mode === DataSourceMode.SEARCH) {
                return null;
            }

            if(!this.textboxHigherCatchupBegAge.isEmpty()){
                if (this.textboxHigherCatchupBegAge.getDataValue()> this.textboxHigherCatchupEndAge.getDataValue()) {
                    return {
                        isValid: false,
                        validationMessage: "Ending age must be after or equal to beginning age.",
                        component: this.textboxHigherCatchupEndAge
                    };
                }
            }
            return null;
        };
    }

    sourceFedtaxtableAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            this.setWithholdingInfo();
            this.setAccounts();
        }
    }

    setWithholdingInfo() {
        const isManual = this.activeRow.getBoolean("use_auto_tax_table", false) === false
        this.panelWithholdingInfo.visible = isManual;
        this.tabWithholdingTables.visible = isManual;
    }

    setAccounts() {
        const enableCatchUp = this.activeRow.getBoolean("enable_catchup", false);
        const enableRoth = this.activeRow.getBoolean("enable_roth", false);
        this.panelCatchUpInfo.visible = enableCatchUp;
        this.panelCatchUpInfo.forEveryChildComponent(comp => comp.required = enableCatchUp);
        this.panelCatchUpAccounts.visible = enableCatchUp;
        this.panelCatchUpAccounts.forEveryChildComponent(comp => comp.required = enableCatchUp);
        this.panelRothAccounts.visible = enableRoth;
        this.panelRothAccounts.forEveryChildComponent(comp => comp.required = enableRoth);
        this.panelRothCatchUpAccounts.visible = enableCatchUp && enableRoth;
        this.panelRothCatchUpAccounts.forEveryChildComponent(comp => comp.required = enableCatchUp && enableRoth);
    }
}
